import React from 'react';
import { serviceDetail1 } from '../../../assets/images';
import ArrowForward from '../Icons/ArrowForward';
import convertMoney from 'ui/helpers/utils/convertMoney';
import BtnConfirm from '../BtnConfirm';

interface ModalCheckoutServicesProps {
  selectedPackage: {
    title?: string;
    price?: number;
  };
  selectedCar: {
    vehicleName?: string;
  };
  discountPrice: number;
  selectedVoucher?: number;
}

const ModalCheckoutServices = ({
  selectedPackage,
  selectedCar,
  discountPrice,
}: ModalCheckoutServicesProps) => {
  return (
    <>
      <div className="container flex-col justify-start items-center mt-2 mb-6 ">
        {Object.keys(selectedPackage).length > 0 && (
          <div className="flex flex-row">
            <img src={serviceDetail1.src} height={90} width={160} alt="Service Detail Image" />

            <div className="flex flex-col px-3 items-start">
              <p className="text-sm text-left font-medium text-reliableBlack line-clamp-2 lg:text-lg lg:font-semibold">
                {selectedPackage?.title}
              </p>
              <p className="text-[10px] md:text-sm ">{selectedCar?.vehicleName}</p>
              <div className="flex items-center  lg:font-semibold mb-0">
                <p className="text-sm font-bold text-supportiveRed lg:text-lg">
                  {convertMoney(discountPrice || 0)}
                </p>
                <p className="ml-2 text-xs font-medium lg:text-sm bg-[#BDF2EF] ">{'0'}%</p>
              </div>

              <p className=" text-sm font-medium line-through text-[#656263] mt-0">
                {convertMoney(selectedPackage?.price || 0)}
              </p>
            </div>
          </div>
        )}
      </div>

      <BtnConfirm
        id="btn-filter-modal-service-packages"
        block={true}
        className="bg-supportiveRed text-white"
        size="large"
        iconType="fill"
        onClick={() => {}}
      >
        <div className="flex md:justify-center justify-end items-center gap-3">
          <div className="flex flex-col md:text-center text-end py-1.5">
            <p className="text-base font-bold uppercase">CEK KERANJANG</p>
          </div>
          <ArrowForward size={20} color="#FFFEFE" />
        </div>
      </BtnConfirm>
    </>
  );
};
export default ModalCheckoutServices;
